import { render } from "./TStatPValue.vue?vue&type=template&id=57eba564&scoped=true"
import script from "./TStatPValue.vue?vue&type=script&lang=js"
export * from "./TStatPValue.vue?vue&type=script&lang=js"

import "./TStatPValue.vue?vue&type=style&index=0&id=57eba564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57eba564"]])

export default __exports__